import { ReactNode } from "react";

import { Logo } from "../../../components/Logo";
import { LanguageSelect } from "../../../components/LanguageSelect/LanguageSelect";
import { currentTheme } from "../../../theme";
import intakeHero from "../../../assets/intake/intake-hero.jpg";
import { IntakeProgress } from "./IntakeProgress";

import "../IntakeFlow.css";

type Props = {
  children: ReactNode;
  progressStep?: number;
  progressTotal?: number;
  progressLabel?: string;
  footer?: ReactNode;
  centerContent?: boolean;
};

export function IntakeShell({
  children,
  progressStep,
  progressTotal = 5,
  progressLabel,
  footer,
  centerContent = false,
}: Props) {
  return (
    <div className="intake-flow">
      <div
        className="intake-flow__photo"
        style={{ backgroundImage: `url(${intakeHero})` }}
        aria-hidden="true"
      />
      <div className="intake-flow__panel">
        <header className="intake-flow__header">
          <div className="intake-flow__lang">
            <LanguageSelect color={currentTheme.textColor} />
          </div>
          <Logo size={120} style={{ maxWidth: "100%", height: "auto" }} />
        </header>

        <div
          className={`intake-flow__content${
            centerContent ? " intake-flow__content--center" : ""
          }`}
        >
          {children}
        </div>

        {progressStep != null && (
          <IntakeProgress
            current={progressStep}
            total={progressTotal}
            label={progressLabel}
          />
        )}

        {footer}
      </div>
    </div>
  );
}
